<template>
  <v-data-table
    :headers="headers"
    :items="formalities"
    class="elevation-1"
    sort-by="internalCode"
    :search="search"
    dense
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Buscar"
          append-icon="mdi-magnify"
          class="mt-3 py-2 mr-2"
        ></v-text-field>
        <FormalityDialog></FormalityDialog>
      </v-toolbar>
    </template>
    <template v-slot:item.isInternal="{ item }">
      {{ item.isInternal ? 'Sí' : 'No' }}
    </template>
    <template v-slot:item.actions="{ item }">
      <formality-dialog :item="item"></formality-dialog>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import FormalityDialog from '@/components/FormalityDialog.vue'
// import firebaseApi from '../api/firebaseApi'
moment.locale('es')
export default {
  name: 'Formalities',
  components: {
    FormalityDialog
  },
  props: {
    formalities: Array
  },
  data: () => ({
    dialog: false,
    search: null,
    loading: false,
    dialogItem: false,
    priorityObj: {
      1: { text: 'Alta', color: 'error' },
      2: { text: 'Media', color: 'warning' },
      3: { text: 'Baja', color: 'success' }
    },
    statusObj: {
      published: { text: 'publicado', color: 'success' },
      draft: { text: 'borrador', color: 'info' },
      archived: { text: 'archivado', color: 'grey' }
    }
  }),

  mounted () {
  },

  computed: {
    headers () {
      return [
        { text: 'Código', value: 'internalCode' },
        { text: 'Nombre', value: 'name' },
        { text: 'Departamento', value: 'cc' },
        { text: 'Es interno', value: 'isInternal' },
        { text: '', value: 'actions', sortable: false }
      ]
    },
    ...mapGetters('user', [
      'getUser'
    ]),
    // ...mapGetters('products', [
    //   'getProducts'
    // ]),
    ...mapGetters('company', [
      'getCompany'
    ])
  },

  watch: {
  },

  methods: {
    emitUpdated () {
      this.$emit('updated')
    },

    getDateFormat (date) {
      return moment(date, 'x').format('L')
    },

    customFilter (item, queryText /* itemText /**/) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.code.toString().toLowerCase()
      const searchText = queryText.toString().toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
    },

    editItem (item) {
    },

    deleteItem (item) {
    },

    save () {
    },
    ...mapActions('inventories', ['insertInventory'])

  }
}
</script>
